import { NavigationService } from './../../../../core/services/navigation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { CloudTypes, Entities } from 'src/app/core/models/globals';
import { HeaderService } from '../../../../core/services/header.service';
import { DeploymentService } from '../../../../core/services/deployment.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PoweroffConfirmationComponent } from '../../modals/poweroff-confirmation/poweroff-confirmation.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-deployment-main-panel',
  templateUrl: './deployment-main-panel.component.html',
  styleUrls: ['./deployment-main-panel.component.scss'],
})
export class DeploymentMainPanelComponent implements OnInit {

  lastRefreshedTime: Date;
  depName: string;
  cloudType: string;
  isOnPremise: boolean = false;
  activeLeftPanelIndex: number = 0;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private navService: NavigationService,
    private headerService: HeaderService,
    private depService: DeploymentService
  ) {}

  ngOnInit(): void {
    this.cloudType = this.route.snapshot.params['cloudType'] || this.route.parent.snapshot.params['cloudType']
    this.navService.sendCloud(this.cloudType)
    this.navService.subNavData(Entities.Home);
    if (this.cloudType == CloudTypes.OnPremise) {
      this.isOnPremise = true;
    }
    this.navService.breadcrumbDeployment.subscribe(
      (x) =>
        (this.depName =
          x ||
          this.route.snapshot.params['deploymentName'] ||
          this.route.parent.snapshot.params['deploymentName'])
    );
    this.navService.sendLeftPanelIndex(0);
    this.navService.sendLastUpdate(this.headerService.getUserNewDate());
    this.navService.lastUpdateTime.subscribe((x) => {
      this.lastRefreshedTime = x;
    });
    this.navService.index.subscribe((x) => { this.activeLeftPanelIndex = x });
  }

  powerOffGracefully() {
    const dialogRef = this.dialog.open(PoweroffConfirmationComponent, {
      width: '30%',
      autoFocus: true,
      disableClose: true,
      data: { depName: this.depName, action: "Power Off" },
    })
    dialogRef.afterClosed().subscribe(async res => {
      if (res) {
        this.depService.powerOffGracefully(this.depName).subscribe({
          next: (data: { actionMessage: string}) => {
            this.snackBar.open(
              data.actionMessage,
              'Ok', {
                duration: 5000,
              }
            );
          }, error: (err: HttpErrorResponse) => {
            this.snackBar.open(
              err.error.actionMessage,
              'Ok', {
                duration: 5000,
              }
            );
          }
        })
      }
    })
  }

  powerOnGracefully() {
    const dialogRef = this.dialog.open(PoweroffConfirmationComponent, {
      width: '30%',
      autoFocus: true,
      disableClose: true,
      data: { depName: this.depName, action: "Power On" },
    })
    dialogRef.afterClosed().subscribe(async res => {
      if (res) {
        this.depService.powerOnGracefully(this.depName).subscribe({
          next: (data: { actionMessage: string }) => {
            this.snackBar.open(
              data.actionMessage,
              'Ok', {
              duration: 5000,
            }
            );
          }, error: (err: HttpErrorResponse) => {
            this.snackBar.open(
              err.error.actionMessage,
              'Ok', {
                duration: 5000,
            });
          }
        })
      }
    })
  }

  refreshComponent() {
    let url = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }
}
